import { Injectable } from '@angular/core';
import { getIncentiveProgramName } from '../../project/project.functions';
import { getFormTypeName } from '../form.functions';
import { incentiveCategory } from '../../project/project.constants';
import { userType } from '../../user/user.constants';

@Injectable()
export class FormTitleService {
  requiredAttachments: string[] = [];

  constructor() {}

  getFormTitle(
    program: string,
    formType: string,
    legislationRule?: string
  ): string {
    const incentiveProgramName = getIncentiveProgramName(program);
    var formTypeName;

    if (program == "DM" && formType == "audit") {
      formTypeName = 'Expenditure Verification Report'
    } else {
      formTypeName = getFormTypeName(formType);
    }

    let title = `${incentiveProgramName} Program ${formTypeName}`;

    if (
      legislationRule &&
      !incentiveCategory.entertainment.incentivePrograms.includes(program)
    ) {
      title += ` (${legislationRule})`;
    }

    return title;
  }
}
